// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:14
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class TimerScheduleOperation_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.TimerScheduleOperation';
  $t: string = 'SagaBase.Defines.TimerScheduleOperation';

  public static GetMembers(): string[] {
    return ['Object', 'DbOperation', 'QueueingOperation'];
  }

  public GetMembers(): string[] {
    return TimerScheduleOperation_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Object: any;
  public DbOperation: SagaBase.DbOperationType = SagaBase.DbOperationType.None;
  public QueueingOperation: SagaBase.QueueingOperationType = SagaBase.QueueingOperationType.None;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
